import { format } from "date-fns";

const Timer = {
  getDate: (dateStr: Date) => {
    return format(dateStr, "dd MMM yyyy");
  },
  getTime: (dateStr: Date) => {
    return format(dateStr, "hh:mm a");
  },
};

export default Timer;
